import Link from "next/link";
import { ArrowRight } from "lucide-react";

import BasicBlock from "@/components/shared/basic-block";
import { SectionHeader } from "@/components/marketing/sections";
import { getRelatedPages } from "@/lib/seo/related";
import type { MarketingPageKind } from "@/lib/seo/pages";

const KIND_LABELS: Record<MarketingPageKind, string> = {
  feature: "Feature",
  tool: "Free tool",
  useCase: "Use case",
  calculator: "Calculator",
  glossary: "Glossary",
  idea: "Video ideas",
  compare: "Comparison",
  language: "Caption language",
  captionStyle: "Caption style",
  doc: "API docs",
};

const RelatedPages = ({
  path,
  count = 6,
  header = "Keep exploring",
}: {
  path: string;
  count?: number;
  header?: string;
}) => {
  const pages = getRelatedPages(path, count);

  if (!pages.length) return null;

  return (
    <BasicBlock
      header={<SectionHeader>{header}</SectionHeader>}
      contentStyle="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6"
    >
      {pages.map((page) => (
        <Link
          key={page.path}
          href={page.path}
          prefetch={false}
          className="group flex flex-col gap-2 rounded-2xl border border-[#EFF2FF] bg-white p-6 shadow-sm transition-colors hover:border-[#335CFF]"
        >
          <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
            {KIND_LABELS[page.kind]}
          </span>
          <div className="flex items-center justify-between">
            <h3 className="text-base font-semibold text-[#101828] transition-colors group-hover:text-[#335CFF]">
              {page.title}
            </h3>
            <ArrowRight
              className="size-4 -translate-x-1 text-[#335CFF] opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100"
              strokeWidth={2.5}
            />
          </div>
          <p className="text-sm leading-normal text-[#525866]">{page.description}</p>
        </Link>
      ))}
    </BasicBlock>
  );
};

export default RelatedPages;
